const Title = () => {
    return (
        <div>
            <h1>Covid Tracker</h1>
        </div>
    );
};

export default Title;